import { createCrudPage } from './factories/crud-page.js';
import { escapeHtml } from '../core/dom/escape-html.js';

export default createCrudPage({
  title: 'Icons',
  basePath: '/icons',
  columns: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'svg_url', label: 'Preview',
      render: (v) => v ? `<img src="${escapeHtml(String(v))}" class="option-icon-img" alt="">` : '',
      renderHtml: true },
  ],
  fields: [
    { key: 'name', label: 'Name', type: 'text', required: true },
    { key: 'svg_url', label: 'SVG file', type: 'file', accept: '.svg,image/svg+xml', photo: true },
  ],
});
